import React from 'react';
import logo from '../../assets/footer_logo.png'; // You can update this logo as needed
import './Footer.scss';
import { FaFacebookF, FaInstagram, FaTwitter} from "react-icons/fa";
import { Link } from 'react-router-dom';
import call from '../../assets/footer/calling.png';
import time from '../../assets/footer/time.png';
import location from '../../assets/footer/location.png';

const Footer = () => {

    const footerContacts = [
        {
            'title': 'Phone Number',
            'info': '8904674189',
            'icon': call
        },
        {
            'title': 'Open Hour',
            'info': '09:00 AM - 09:00 PM',
            'icon': time
        },
        {
            'title': 'Clinic Address - 1',
            'info': 'HUDA Staff Colony, Sector 16, Faridabad, Haryana 121002',
            'icon': location
        },
        {
            'title': 'Clinic Address - 2',
            'info': 'SCF 6 & 7, Opp. SRS Royal Hills, Sector 86, Faridabad, Haryana 121002',
            'icon': location
        }
    ];
    

    return (
        <footer className='pt-100 pb-70'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-5">
                        <div className="footer-logo">
                            {/* https://i.ibb.co/5sxQ1SB/Blue-Modern-Dental-Clinic-logo.png */}
                            {/* <img src= "https://i.ibb.co/5sxQ1SB/Blue-Modern-Dental-Clinic-logo.png"alt="Dr. Bhagat Tanwar's Clinic Logo" /> Update with actual logo */}
                        </div>
                        <p>Dr. Bhagat Tanwar is a trusted Dentist & Endodontist in Faridabad specializing in Conservative Dentistry & Endodontics. Quality care with a personal touch.</p>

                        <div className="social-logo">
                            <p>Follow us on</p>
                            <ul>
                                <li><a href="https://www.facebook.com/drbhagattanwardental" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a></li>
                                <li><a href="https://twitter.com/drbhagattanwar" target="_blank" rel="noopener noreferrer"><FaTwitter /></a></li>
                                <li><a href="https://www.instagram.com/drbhagattanwardental" target="_blank" rel="noopener noreferrer"><FaInstagram /></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                        <div className="footer-link">
                            {/* You can add more quick links here if needed */}
                            {/* <p>Quick Links</p>
                            <ul>
                                <li><Link to="/">About Us</Link></li>
                                <li><Link to="/">Services</Link></li>
                                <li><Link to="/">Appointments</Link></li>
                            </ul> */}
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-5">
                        <div className="footer-contact">
                            <p>Contact & Information</p>

                            {
                                footerContacts.map((footerContact, index) => {
                                    return  <div className="contact-list" key={index}>
                                                <div className="contact-icon">
                                                    <img src={footerContact.icon} alt={footerContact.title} />
                                                </div>
                                                <div className="contact-text">
                                                    <p>{footerContact.title}</p>
                                                    <h5>{footerContact.info}</h5>
                                                </div>
                                            </div>
                                })
                            }
                        </div>
                    </div>
                </div>

                <div className="copyright-area">
                    <div className='copy-text'>
                        <p>&copy; Dr. Bhagat Tanwar Dental Clinic. All Rights Reserved</p>
                    </div>  
                    <div className='copy-links'>
                        <ul>
                            <li><Link to='/terms-of-use'>Terms of Use</Link></li>
                            <li><Link to='/privacy-policy'>Privacy Policy</Link></li>
                        </ul>
                    </div>                          
                </div>

                <div className="row footer-keywords">
  <div className="col-12">
    <div className="keyword-grid">
      {[
        // General Dentist Keywords
        "Best Dentist in Faridabad", "Top Dentist Near Me", "Dental Clinic Near Me", "Dental Doctor Near Me",
        "Affordable Dentist in Faridabad", "Dentist for Kids", "Emergency Dental Clinic", "Family Dentist in Faridabad" ," Best orthodentist in Faridabad",

        // Treatment-Based
        "Root Canal Treatment", "Single Sitting RCT", "Painless Root Canal", "Teeth Whitening", "Zoom Teeth Whitening",
        "Laser Teeth Whitening", "Dental Braces", "Metal Braces", "Ceramic Braces", "Invisible Braces", "Invisalign Treatment",
        "Smile Design", "Cosmetic Dentistry", "Full Mouth Rehabilitation", "Dental Veneers", "Dental Bonding", "Gap Closure Treatment",
        "Tooth Filling", "Dental Crowns & Bridges", "Wisdom Tooth Extraction", "Tooth Removal", "Dental Cleaning",
        "Scaling and Polishing", "Gum Disease Treatment", "Laser Gum Treatment", "Periodontal Treatment", "Bleeding Gums Treatment",
        "Tooth Sensitivity Treatment", "Fluoride Treatment",

        // Implants & Dentures
        "Dental Implants", "Best Dental Implant Clinic in Faridabad", "Full Mouth Implants", "Immediate Implants", "All-on-4 Implants",
        "Fixed Teeth in 3 Days", "Dentures", "Complete Dentures", "Partial Dentures", "Flexible Dentures", "Implant-Supported Dentures",

        // Pediatric
        "Pediatric Dentist in Faridabad", "Best Dentist for Kids", "Child Dental Specialist", "Milk Teeth Extraction",
        "Fluoride Application for Children", "Dental Sealants for Kids",

        // Orthodontics
        "Braces Treatment in Faridabad", "Invisible Braces Faridabad", "Best Orthodontist in Faridabad", "Self-Ligating Braces", "Damon Braces",
        "Aligners in Faridabad", "Invisalign Cost in Faridabad",

        // Oral Surgery
        "Tooth Extraction", "Wisdom Tooth Surgery", "Jaw Fracture Treatment", "TMJ Treatment", "Oral Cancer Screening",

        // Branding Keywords
        "Best Dental Clinic in Faridabad", "Affordable Dental Care in Faridabad", "24x7 Dental Clinic Faridabad", "Laser Dental Clinic Faridabad",
        "Multispeciality Dental Clinic Faridabad", "Pain-Free Dentistry Faridabad", "Gentle Dental Care Faridabad", "Advanced Dental Centre Faridabad",

        // Long-Tail Keywords
        "How much does a root canal cost in Faridabad?", "Best clinic for teeth whitening in Faridabad", "Invisalign vs Braces Faridabad",
        "Dental implant cost in Faridabad", "Child-friendly dentist in Faridabad", "Best cosmetic dentist in Faridabad"
      ].map((item, index) => (
        <p key={index}>{item}</p>
      ))}
    </div>
  </div>
</div>



            </div>
        </footer>
    );
};

export default Footer;
